import React from "react";
import mockMenuData from "../data/menulist";

const Foodmenu = () => {
  const menuCategories = Object.keys(mockMenuData);

  return (
    <div className="container py-3" style={{ backgroundColor: "#000", color: "#fff" }}>
      {/* Foodmenu Section */}
        {/* Tabs Navigation */}
        <ul className="nav nav-pills justify-content-center mb-4">
          {menuCategories.map((category, index) => (
            <li className="nav-item" key={index}>
              <a
                className={`nav-link ${index === 0 ? "active" : ""}`}
                data-bs-toggle="pill"
                href={`#${category}`}
                style={{ color: "#", fontWeight: "bold" }}
              >
                {category.replace(/([A-Z])/g, " $1").trim()}
              </a>
            </li>
          ))}
        </ul>

        {/* Tab Content */}
        <div className="tab-content">
          {menuCategories.map((category, index) => (
            <div
              id={category}
              key={index}
              className={`container tab-pane ${index === 0 ? "active" : ""}`}
            >
              <div className="row justify-content-center">
                <div className="col-md-8">
                  {/* Menu Items List */}
                  {mockMenuData[category].map((subCategory, subIndex) => (
                    <div key={subIndex} className="mb-4">
                      <h3 className="text-uppercase text-center" style={{ color: "#fff" }}>
                        {subCategory.category}
                      </h3>
                      <div className="table-responsive">
                        <table className="table text-white border-0">
                          <tbody>
                            {subCategory.items.map((item, itemIndex) => (
                              <tr key={itemIndex} style={{ borderBottom: "5px " }}>
                                <td className="text-start " style={{ fontWeight: "bold", backgroundColor: "#000", color: "#fff" }}>{item.name}</td>
                                <td className="text-end" style={{ fontWeight: "bold" ,backgroundColor: "#000", color: "#fff"}}>{item.price.toFixed(2)}€</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

    </div>
  );
};

export default Foodmenu;